<template>
  <div @touchmove.prevent>
    <CustomDialogWrapper dialogType="showBindGameAccount" @closeDialog="closeDialog">
      <template #title>
        <p :class="$style.title">游戏账号信息</p>
      </template>
      <template #main-content>
        <van-form v-if="isBindAccount && !isEditAccount">
          <div :class="[`${$style['form-item']}`, $style.info]">
            <span>游戏账号：</span>
            <div :class="$style['info-value']">{{ userBindInfo.game_account }}</div>
          </div>
          <div :class="[`${$style['form-item']}`, $style.info]">
            <span>最后一次登陆游戏：</span>
            <div :class="$style['info-value']">{{ userBindInfo.agreement_game_name }}</div>
          </div>
          <div :class="[`${$style['form-item']}`, $style.info]">
            <span>游戏角色名：</span>
            <div :class="$style['info-value']">{{ userBindInfo.role_name }}</div>
          </div>
        </van-form>
        <van-form validate-first v-else>
          <div :class="`${$style['form-item']}`">
            <span :class="active == 1 && $style.active">游戏账号</span>
            <van-field
              v-model="gameAccount"
              :class="`${$style.value} ${active == 1 && $style.active}`"
              clearable
              @focus="handleBlur(1)"
            />
          </div>
          <div :class="`${$style['form-item']}`">
            <span :class="active == 2 && $style.active">游戏密码</span>
            <van-field
              v-model="password"
              :class="`${$style.value} ${active == 2 && $style.active}`"
              :type="pwdShowType"
              clearable
              @focus="handleBlur(2)"
            >
              <template #right-icon>
                <van-icon name="closed-eye" v-if="pwdShowType" @click="pwdShowType = ''" />
                <van-icon name="eye" v-else @click="pwdShowType = 'password'" />
              </template>
            </van-field>
          </div>
        </van-form>
      </template>
      <template #footer>
        <van-button :class="$style.submit" type="info" @click="submit">
          {{ isBindAccount && !isEditAccount ? '修改' : '绑定账号' }}</van-button
        >
      </template>
    </CustomDialogWrapper>
  </div>
</template>

<script>
import CustomDialogWrapper from './CustomDialogWrapper';
import { Form, Field, Button, Dialog, Toast, Icon } from 'vant';
import { bindUserGameAccount } from '@/api/app';
import { getUserBindInfo } from '@/api/personalCenter';
import { mapState, mapActions, mapMutations } from 'vuex';
export default {
  components: {
    CustomDialogWrapper,
    VanForm: Form,
    VanField: Field,
    VanButton: Button,
    VanIcon: Icon,
  },
  data() {
    return {
      showBindPhone: false,
      gameAccount: '', // 账号
      password: '', // 密码
      pwdShowType: 'password',
      active: undefined,
      brushFlag: false, // 防止重复提交
      userBindInfo: {}, // 用户绑定游戏账号信息
      isEditAccount: false, // 是否确认修改账号
    };
  },
  computed: {
    ...mapState('account', {
      userInfo: (state) => state.userInfo,
    }),
    // 判断是否绑定游戏账号
    isBindAccount() {
      let flag = this.userInfo.game_user_id != 0 ? true : false;
      return flag;
    },
    // 判断是否是活动页
    isActivity() {
      return this.$route.name.includes('activity');
    },
  },
  created() {
    this.getUserBindInfo();
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_BIND_GAME: 'CHANGE_BIND_GAME',
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING',
      CHANGE_BIND_ACCOUNT_DIALOG: 'CHANGE_BIND_ACCOUNT_DIALOG',
    }),
    ...mapActions('account', {
      getUserInfo: 'getUserInfo',
    }),
    // 立即验证
    async submit() {
      if (this.isBindAccount && !this.isEditAccount) {
        if (['giftCenter.home', 'personalCenter.home'].includes(this.$route.name)) {
          this.closeDialog()
          this.CHANGE_BIND_ACCOUNT_DIALOG(true);
        } else {
          this.isEditAccount = true;
        }
        return;
      }
      if (!this.gameAccount) {
        Toast('请先输入游戏账号哦!');
        return;
      }
      if (!this.password) {
        Toast('请输入密码哦!');
        return;
      }
      if (this.brushFlag) return;
      this.brushFlag = true;
      try {
        // 论坛页面绑定账号接口
        const r = await bindUserGameAccount({
          account: this.gameAccount,
          password: this.password,
        });
        Toast.success('绑定游戏账号成功');
        this.CHANGE_BIND_GAME(false);
        this.getUserInfo();
      } catch (error) {
        Toast.fail(error.message);
      } finally {
        this.brushFlag = false;
      }
    },
    handleBlur(type) {
      this.active = type;
    },
    closeDialog() {
      this.CHANGE_BIND_GAME(false);
    },
    async getUserBindInfo() {
      this.CHANGE_SHOW_LOADING(true);
      const r = await getUserBindInfo();
      this.userBindInfo = r.data;
      this.CHANGE_SHOW_LOADING(false);
    },
  },
};
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.title {
  margin-bottom: 30px;
  font-size: 15px;
  line-height: 18px;
  color: #9d9d9d;
}
.form-item {
  display: flex;
  margin: auto;
  align-items: center;
  font-size: 13px;
  width: 90%;
  > span {
    margin-right: 20px;
    flex: none;
    color: #9d9d9d;
    display: inline-block;
    &.active {
      color: #33bdfe;
    }
  }
  .value {
    @include border-bottom-1px;
    padding: 5px 10px;
    &.active {
      &::before {
        border-color: #33bdfe;
      }
    }
  }
  .get-code-btn {
    padding: 0 10px;
    height: 20px;
    border-radius: 20px;
    color: #33bdfe;
    border-color: #33bdfe;
    font-size: 12px;
  }
}
.info {
  width: 100%;
  font-size: 13px;
  line-height: 35px;
  > span {
    width: 50%;
    margin-right: 10px;
    text-align: right;
  }
  .info-value {
    @include ellipsis(1);
    width: 50%;
  }
}
.submit {
  width: 200px;
  border-radius: 22px;
  background: linear-gradient(-90deg, rgba(36, 180, 254, 1), rgba(82, 208, 255, 1));
  border: none;
}
</style>
